import { ServicingConfigTypes } from "./types/servicing-config-types";

export const ServicingConfig: ServicingConfigTypes = {
  xxxFeatureToggle: {
    value: "Y",
  },
};
